import { render, staticRenderFns } from "./relatorioParcelasDescontadasPaisagem.vue?vue&type=template&id=c6b00000"
import script from "./relatorioParcelasDescontadasPaisagem.vue?vue&type=script&lang=js"
export * from "./relatorioParcelasDescontadasPaisagem.vue?vue&type=script&lang=js"
import style0 from "./relatorioParcelasDescontadasPaisagem.vue?vue&type=style&index=0&id=c6b00000&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports